import { forwardRef } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import IndeterminateSpinner from '@ebsco-ui/indeterminate-spinner';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["className", "direction", "loadingMessage", "showMessage", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Loading = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
      loadingMessage = _ref.loadingMessage,
      _ref$showMessage = _ref.showMessage,
      showMessage = _ref$showMessage === void 0 ? true : _ref$showMessage,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getBlocksWith = createBemBlockBuilder(["eb-loading", className]);
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({
    className: cn(getBlocksWith(), getBlocksWith("--".concat(direction)), getBlocksWith("--".concat(size))),
    role: "status",
    "aria-live": "polite",
    "aria-label": loadingMessage,
    ref: ref,
    tabIndex: -1
  }, rest), {}, {
    children: [/*#__PURE__*/jsx(IndeterminateSpinner, {
      className: getBlocksWith("__spinner"),
      level: size === "small" ? "component" : "page"
    }), showMessage && /*#__PURE__*/jsx("p", {
      className: getBlocksWith("__message"),
      children: loadingMessage
    })]
  }));
});
Loading.displayName = "Loading";

export { Loading as default };
//# sourceMappingURL=loading-esm.js.map
